import React from 'react'
import { Link } from 'react-router-dom'
// import "../App.css"

export default function CountryCard({ name, flag, population, region, capital, data }) {
  // console.log(data)
  return (
    <Link className="country-card" to={`/${name}`} state={data}>
      <img src={flag} alt={name + ' Flag'} style={{height:"200px"}}/>
      <div className="card-text">
        <h3 className="card-title">{name}</h3>
        <p>
          <b>Population: </b>
          {population.toLocaleString('en-IN')}
        </p>
        <p>
          <b>Region: </b>{region}
        </p> 
        <p>
          <b>Capital: </b>{capital}
        </p>
      </div>
    </Link>
  )
}